// THE BUILDING GRID OVER A SHEET PAGE (owner, 2026-10-24: "do the same grid fix on the 2D sheets view"): the
// project's own lettered and numbered lines, labelled at both ends the way G draws them in 3D - never an
// anonymous lattice. Lines are page percent (api/glance/sheetGrid), so the overlay sits over the page image at
// any zoom; the parent must be position:relative and exactly the image's size.
import React from "react";

const INK = "#2F6FB3";

export default function SheetGridOverlay({ lines }) {
  if (!lines || !lines.length) return null;
  const inside = (p) => p[0] >= 0 && p[0] <= 100 && p[1] >= 0 && p[1] <= 100;
  // A label sits at an end that is on the page; an end off the page is pulled to the page's edge along its line.
  const clampEnd = (p) => [Math.min(99, Math.max(1, p[0])), Math.min(99, Math.max(1, p[1]))];
  return (
    <div data-testid="sheet-grid-overlay" style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}>
      <svg viewBox="0 0 100 100" preserveAspectRatio="none" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} aria-hidden="true">
        {lines.map((l) => (
          <line key={`${l.axis}${l.label}`} x1={l.a[0]} y1={l.a[1]} x2={l.b[0]} y2={l.b[1]}
            stroke={INK} strokeWidth="1" strokeDasharray="6 4" opacity="0.75" vectorEffect="non-scaling-stroke" />
        ))}
      </svg>
      {lines.flatMap((l) => [l.a, l.b].map((p, i) => {
        const at = inside(p) ? p : clampEnd(p);
        return (
          <span key={`${l.axis}${l.label}-${i}`} data-grid-label={l.label} style={{
            position: "absolute", left: `${at[0]}%`, top: `${at[1]}%`, transform: "translate(-50%, -50%)",
            minWidth: 18, height: 18, padding: "0 3px", borderRadius: 9, border: `1px solid ${INK}`, background: "#fff",
            color: INK, fontSize: 10, fontWeight: 600, lineHeight: "16px", textAlign: "center", boxSizing: "border-box",
          }}>{l.label}</span>
        );
      }))}
    </div>
  );
}
